<script lang="typescript">
    import { EyeWearType, FocalType } from "./types";
    import { fade } from "svelte/transition";

    export let activeFocalType: FocalType;
    export let activeEyeWearType: EyeWearType;
</script>

<section
    class="
    w-full
    h-full
    items-end
    justify-center
    text-primary
  absolute
  bottom-0
    flex"
>
    {#if activeFocalType !== null}
        <div
            class="bg-white z-35 w-full min-h-3/4 text-xl p-4 opacity-95"
            transition:fade={{ duration: 200 }}
        >
            <div class="ml-16 mr-4 mt-4 text-black">
                {#if activeFocalType === FocalType.SINGLE_VISION}
                    <img src="/img/single-vision_lens.png" />
                    <p>
                        Single vision lenses are designed to correct your vision at one distance
                        only, with a single prescription covering the entire surface of the lens.
                    </p>
                    <p>
                        They’re usually prescribed for people who are either longsighted or
                        short-sighted, and who need glasses just for things like reading, driving,
                        or working at a computer.
                    </p>
                {:else if activeFocalType === FocalType.CHILDREN_SINGLE_VISION}
                    <img src="/img/single-vision_lens.png" />
                    <p>
                        Like our single vision lens, this lens corrects your vision at one distance.
                        It’s designed specifically for children who’re either long-sighted or
                        short-sighted and comes with the option to upgrade to our extra safe lenses,
                        which are great for active children & provide 100% UV protection.
                    </p>
                {:else if activeFocalType === FocalType.VARIFOCAL}
                    <img src="/img/varifocal_lens.png" />
                    <p>
                        Varifocals are the best solution when more than one prescription is needed
                        to correct your vision. They combine two prescriptions into one lens so you
                        don’t have to carry two pairs of glasses but can still have clear vision at
                        all distances.
                    </p>
                    <p>
                        The more advanced the varifocal lens, the less soft focus or distortion the
                        lens will have.
                    </p>
                {/if}
            </div>
        </div>
    {/if}

    {#if activeEyeWearType !== null && activeFocalType === null}
        <div
            transition:fade={{ duration: 200 }}
            class="bg-cover bg-no-repeat relative bg-white min-h-2/3 text-xl p-4 opacity-95 w-full"
            style={`background-image: url(/img/contact-lens/splash-mouseover.png)`}
        >
            <div class="ml-16 mr-4 mt-4 text-black">
                <p>
                    Contact lenses work in a similar way to glasses: the lens focuses images onto
                    your retina to give you clear, sharp vision. Each contact lens moves naturally
                    with you because it floats on the tear fluid that covers the lens of your eye.
                </p>
                <p>
                    Contact lenses can correct everything from short- and long-sightedness to
                    astigmatism and age-related eye conditions such as presbyopia.
                </p>
            </div>
        </div>
    {/if}
</section>

<style>
    p {
        @apply mt-2;
    }

    img {
        @apply w-2/3 mx-auto mb-5;
    }
</style>
